<template>
  <v-dialog v-model="dialog" persistent max-width="680">
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <v-card :key="key">
        <v-app-bar flat color="primary">
          <v-toolbar-title class="text-h6 white--text pl-0">
            {{ $t("note_order") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="$emit('close')" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <ng-textarea-keyboard v-model="note" :label="$t('note')"></ng-textarea-keyboard>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="primary" outlined @click="$emit('close')" :title="$t('Cancel')">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn color="primary" :disabled="invalid" @click="setNote()" :title="$t('accept')">
            {{ $t("accept") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<style>
.bg_modal {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) 0% 0% / cover no-repeat;
}
</style>
<script>
import NgTextareaKeyboard from '../../../gui/NgTextareaKeyboard.vue';
const DEFAULT_ITEM = { reason: "" };
export default {
  components: { NgTextareaKeyboard },
  name: "CartNote",
  data: () => ({
    searched: false,
    key: 0,
    item: JSON.parse(JSON.stringify(DEFAULT_ITEM)),
    note: ''
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    order: Object,
  },
  mounted() {
    this.note = this.order.getNote();
  },
  methods: {
    selected() {
      const obj = JSON.parse(JSON.stringify(this.item));
      this.clear();
      this.searched = false;
      this.$emit("selected", obj);
      this.key++;
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    setNote() {
      this.$pos.setNote(this.order, this.note);
      this.$emit("cancel");
    }
  },
};
</script>